import { useDispatch } from 'react-redux'

import clsx from 'clsx'

import { ReplyLeft } from 'app/components/icons'
import { setReplyingMessage } from 'app/redux/messages/messages.actions'
import styles from './styles.module.scss'

function Reply({ messageType, messageId, messageContent, languageInfo, type }) {
  const dispatch = useDispatch()

  const handlesetReplyingMessage = () => {
    const dataObj = {
      id: messageId,
      content: '',
      msgType: messageType,
    }

    const replyContentForTypes = {
      text: messageContent,
      emoji: messageContent,
      image: languageInfo.texts.image,
      audio: languageInfo.texts.voice,
      file: languageInfo.texts.file,
      video: languageInfo.texts.video,
      compress: languageInfo.texts.file,
    }

    const content = replyContentForTypes[messageType] || '-'

    dataObj['content'] = content

    dispatch(setReplyingMessage(dataObj))
  }

  return (
    <div
      data-type={type}
      onClick={handlesetReplyingMessage}
      className={clsx(styles.message_reply, 'user_message_reply')}
    >
      <ReplyLeft className={styles.message_reply_icon} color="#000" />
    </div>
  )
}

export default Reply
